import { pedidoService } from '@/services/pedidoService';

const state = {
  pedidos: []
};

const getters = {
  pedidos: state => state.pedidos,
};

const actions = {
  async fetchPedidos({ commit }) {
    const pedidos = await pedidoService.getPedidos();
    commit('SET_PEDIDOS', pedidos);
  },
  async fetchPedidosAPI({ commit }) {
    const pedidos = await pedidoService.getPedidosAPI();
    commit('SET_PEDIDOS', pedidos);
  },
  async updatePedido({ commit }, pedido) {
    await pedidoService.updatePedido(pedido);
    commit('UPDATE_PEDIDO', pedido);
  }
};

const mutations = {
  SET_PEDIDOS: (state, pedidos) => state.pedidos = pedidos,
  UPDATE_PEDIDO: (state, updPedido) => {
    const index = state.pedidos.findIndex(pedido => pedido.id_saida == updPedido.id_saida);
    if (index !== -1) state.pedidos.splice(index, 1, updPedido);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}